import { cn } from "@/lib/utils";
import { EVENT_CATEGORIES, type EventCategoryKey } from "@/lib/constants";

const CATEGORY_CLASSES: Record<EventCategoryKey, string> = {
  LIBROS: "bg-[color-mix(in_oklch,var(--cat-libros)_15%,transparent)] text-[var(--cat-libros)]",
  POESIA: "bg-[color-mix(in_oklch,var(--cat-poesia)_15%,transparent)] text-[var(--cat-poesia)]",
  CHARLAS: "bg-[color-mix(in_oklch,var(--cat-charlas)_15%,transparent)] text-[var(--cat-charlas)]",
  TALLERES: "bg-[color-mix(in_oklch,var(--cat-talleres)_15%,transparent)] text-[var(--cat-talleres)]",
  CUENTACUENTOS:
    "bg-[color-mix(in_oklch,var(--cat-cuentacuentos)_15%,transparent)] text-[var(--cat-cuentacuentos)]",
  OTRO: "bg-[color-mix(in_oklch,var(--cat-otro)_15%,transparent)] text-[var(--cat-otro)]",
};

export function CategoryBadge({
  category,
  className,
}: {
  category: EventCategoryKey;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex w-fit shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
        CATEGORY_CLASSES[category],
        className
      )}
    >
      {EVENT_CATEGORIES[category].label}
    </span>
  );
}
